import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { LoadingSpinner } from './ui/loading-spinner';

import { getApiBaseUrl } from '../utils/api';
export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          throw new Error('No session ID found');
        }
        
        const sessionId = sessionIdMatch[1];
        
        // Process session with backend
        const response = await fetch(`${getApiBaseUrl()}/api/auth/session?session_id=${sessionId}`, {
          method: 'GET',
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Authentication failed');
        }
        
        const data = await response.json();
        
        toast.success(`Welcome, ${data.user.name}!`);
        
        // Navigate based on role
        let dashboardUrl = '/dashboard';
        if (data.user.role === 'admin') {
          dashboardUrl = '/admin';
        } else if (data.user.role === 'staff') {
          dashboardUrl = '/staff';
        }
        navigate(dashboardUrl, { 
          replace: true, 
          state: { user: data.user } 
        });
        
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };
    
    processAuth();
  }, [location.hash, navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
}